<template>
      <div class="div_outer_box" v-if="tutorialVideosData && tutorialVideosData.length">
        <div class="deposit_demo_video_section" >
                <div class="custom_container">
                    <div class="withdraws_video_sec">
                        <div v-for="(tut,index) in tutorialVideosData" :key="index">
                            <div class="withdraws-video-con">
                                <div class="video_thm_title">
                                    <p class="para-two">{{ $t(`how-to-${type == 2 ? 'deposit' : 'withdraw'}`, `How To ${type == 2 ? 'deposit' : 'withdraw'}`) }} ({{ tut.lang == 1 ? $t('english','English') : $t('hindi','Hindi') }})</p>
                                </div>
                                <iframe width="100%" height="315" :src="tut.link" frameborder="0" allowfullscreen="allowfullscreen"> </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
   </div>
</template>
<script>
export default {
    name: 'TutorialVideo',
    props:['type'],
    inject: ['walletConfig'],
     computed: {
        tutorialVideosData() {
            return this.walletConfig?.videos?.filter(item => item?.type == this.type);
        },
    },
}
</script>